/* eslint-disable import/prefer-default-export */
export const themes = {
    DEFAULT: 'DEFAULT',
    WARNING: 'WARNING',
    ATTENTION: 'ATTENTION',
    OVERLAY: 'OVERLAY',
    DARKEN: 'DARKEN',
    LIGHTEN: 'LIGHTEN',
    POSITIVE: 'POSITIVE',
    NEGATIVE: 'NEGATIVE',
    SECONDARY: 'SECONDARY',
    INFORMATION: 'INFORMATION',
    NEUTRAL: 'NEUTRAL',
};
